import * as Yup from 'yup';

import { formikRequired } from '../../SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    ownerId: formikRequired,
  });

export default Validator;
